/**
 * Shows a toast, based on a type and an amount of time to show
 *
 * @param type - The type, either 'success' or 'error'
 * @param time - Time to show the toast in milliseconds
 */
function showToast( type, time ) {
	let toastToShow = false;

	if ( type === 'success' ) {
		toastToShow = document.getElementById( 'copied-succesfully' );
	} else {
		toastToShow = document.getElementById( 'copy-failed' );
	}

	if ( toastToShow ) {
		toastToShow.classList.add( 'show' );

		setTimeout( () => {
			toastToShow.classList.remove( 'show' );
		}, time );
	}
}

/**
 * Copies the given data by the trigger to the clipboard
 *
 * @important - The trigger will ONLY be bound if the trigger has the data-to-copy attribute
 * @example - <a href="javascript:;" class="copy-to-clipboard" data-to-copy="This text will be copied">Copy me!</a>
 */
function bindCopyToClipboard() {
	const triggers = document.getElementsByClassName( 'copy-to-clipboard' );

	if ( triggers && [...triggers].length ) {
		[...triggers].forEach( ( element ) => {
			if ( element.hasAttribute( 'data-to-copy' ) ) {
				element.addEventListener( 'click', ( event ) => {
					event.preventDefault();

					navigator.clipboard.writeText( element.getAttribute( 'data-to-copy' ) ).then( ( data ) => {
						showToast( 'success', 2500 );
					}, ( error ) => {
						showToast( 'error', 2500 );
					} );
				} );
			}
		} );
	}
}

export default {
	init() {
		bindCopyToClipboard();
	},
};